import { useContext } from 'react';
import { WorkflowApproversContext } from './context';
export const useWorkflowApprovers = () => {
    const context = useContext(WorkflowApproversContext);
    if (!context) {
        throw new Error('useWorkflowApprovers hook must be used as a child to <WorkflowApproversProvider />');
    }
    return context;
};
